import {
  GET_ATTSCHEDULEDETAIL,
  GET_ATTSCHEDULEDETAIL_SUCCESS,
  GET_ATTSCHEDULEDETAIL_FAIL,
  DELETE_ATTSCHEDULEDETAIL,
  DELETE_ATTSCHEDULEDETAIL_SUCCESS,
  DELETE_ATTSCHEDULEDETAIL_FAIL,
  UPDATE_ATTSCHEDULEDETAIL,
  UPDATE_ATTSCHEDULEDETAIL_SUCCESS,
  UPDATE_ATTSCHEDULEDETAIL_FAIL,
  ADD_NEW_ATTSCHEDULEDETAIL,
  ADD_ATTSCHEDULEDETAIL_SUCCESS,
  ADD_ATTSCHEDULEDETAIL_FAIL,
  ATTSCHEDULEDETAIL_LOADING,
  ATTSCHEDULEDETAIL_RESET,
} from "./actionType";

export const resetAttScheduleDetailState = (actionType) => ({
  type: ATTSCHEDULEDETAIL_RESET,
  payload: { actionType },
});

export const getAttScheduleDetailSuccess = (actionType, data) => ({
  type: GET_ATTSCHEDULEDETAIL_SUCCESS,
  payload: { actionType, data },
});

export const getAttScheduleDetailFail = (actionType, error) => ({
  type: GET_ATTSCHEDULEDETAIL_FAIL,
  payload: { actionType, error },
});

export const getAttScheduleDetail = data => ({
  type: GET_ATTSCHEDULEDETAIL,
  payload: data,
});

export const getAttScheduleDetailLoading = () => ({
  type: ATTSCHEDULEDETAIL_LOADING
});

export const deleteAttScheduleDetail = data => ({
  type: DELETE_ATTSCHEDULEDETAIL,
  payload: data,
});

export const deleteAttScheduleDetailSuccess = data => ({
  type: DELETE_ATTSCHEDULEDETAIL_SUCCESS,
  payload: data,
});

export const deleteAttScheduleDetailFail = error => ({
  type: DELETE_ATTSCHEDULEDETAIL_FAIL,
  payload: error,
});

export const updateAttScheduleDetail = data => ({
  type: UPDATE_ATTSCHEDULEDETAIL,
  payload: data,
});

export const updateAttScheduleDetailFail = error => ({
  type: UPDATE_ATTSCHEDULEDETAIL_FAIL,
  payload: error,
});

export const updateAttScheduleDetailSuccess = data => ({
  type: UPDATE_ATTSCHEDULEDETAIL_SUCCESS,
  payload: data,
});

export const addNewAttScheduleDetail = data => ({
  type: ADD_NEW_ATTSCHEDULEDETAIL,
  payload: data,
});

export const addAttScheduleDetailSuccess = data => ({
  type: ADD_ATTSCHEDULEDETAIL_SUCCESS,
  payload: data,
});

export const addAttScheduleDetailFail = error => ({
  type: ADD_ATTSCHEDULEDETAIL_FAIL,
  payload: error,
});